import ExcelButton from "../../../core/components/ExcelButton";
import useAppointmentExcelExport from "./useAppointmentExcelExport";

/** Masaüstü grid araç çubuğunun en sağındaki Excel düğmesi (yetki yoksa çizilmez). */
export default function AppointmentExcelButton({ view }) {
    const { canExport, exportExcel } = useAppointmentExcelExport(view);
    if (!canExport) return null;
    return (
        <div style={{ marginLeft: 'auto' }}>
            <ExcelButton size="small" style={{ minWidth: 120 }} onClick={exportExcel} />
        </div>
    );
}
